import Ajax from '../util/Ajax';
import LazyLoad from '../vendor/Lazyload';

export default class LoadMoreButton {
  constructor($element) {
    this.$element = $element;

    this.$element.addEventListener('click' , (e) => {
      e.preventDefault();
      this.onClick();
    })
  }

  onClick() {
    const request = new Ajax(this.$element.href);
    request.then((response) => {
      const $dom = new DOMParser().parseFromString(response, 'text/html')
      const $results = $dom.querySelectorAll('.links-table__link');
      const $table = document.querySelector('.links-table');

      $results.forEach(($r) => {
        $r.classList.add('ajax-loaded');
        $table.append($r);
      });

      const $more = $dom.querySelector('.js-load-more');
      const $moreToDelete = document.querySelector('.js-load-more')
      const $moreDiv = $moreToDelete.parentElement;
      $moreDiv.removeChild($moreToDelete);

      if ($more !== null) $moreDiv.append($more);

      const $paginationToDelete = document.querySelector('.links__pagination-nav');
      if ($paginationToDelete !== null) $paginationToDelete.parentElement.removeChild($paginationToDelete);

      const loadMoreButtons = Array.from(document.querySelectorAll('.js-load-more'));
      this.LoadMoreButtons = loadMoreButtons.map(($loadMoreButton) => new LoadMoreButton($loadMoreButton));

      window.attach(document.querySelectorAll('.ajax-loaded .js-attach'));

      this.Lazyloading = new LazyLoad({
        load_delay: 10,
        elements_selector: '.ajax-loaded img, .ajax-loaded .lazy',
        use_native: false,
        callback_loaded: (el) => {
          // add loaded to picture element if exists
          if (el.parentNode) {
            el.parentNode.classList.add('loaded');
            setTimeout(function () {
              if (el && el.parentNode) el.parentNode.classList.add('animated');
            }, 1500);
          }
        },
      });

    });
  }
}



// WEBPACK FOOTER //
// ./scripts/dom/LoadMoreButton.js